/** Wischen nach unten am Kopf eines Blatts schließt es (K3). Reine Entscheidung, damit sie ohne DOM prüfbar ist. */

/** Strecke nach unten, ab der das Blatt beim Loslassen schließt. */
export const SHEET_DISMISS_PX = 80;
/** Kurzer, schneller Wisch (Wurf): schon ab dieser Strecke und dieser Geschwindigkeit. */
export const SHEET_FLING_PX = 40;
export const SHEET_FLING_SPEED = 0.5;

export interface DragEnd {
  /** Verschiebung seit dem Aufsetzen (nach unten positiv). */
  dx: number;
  dy: number;
  ms: number;
}

/** Schließt das Blatt? Nur eine überwiegend senkrechte Bewegung nach unten zählt. */
export function shouldDismissSheet({ dx, dy, ms }: DragEnd): boolean {
  if (dy <= 0 || dy <= 1.5 * Math.abs(dx)) return false;
  if (dy >= SHEET_DISMISS_PX) return true;
  return dy >= SHEET_FLING_PX && ms > 0 && dy / ms > SHEET_FLING_SPEED;
}
